import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../api/client";
import Bauchbinde from "../components/Bauchbinde";
import dayjs from "dayjs";

export default function ProjektorAnsicht4() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [daten, setDaten] = useState(null);
  const [jetzt, setJetzt] = useState(new Date());

  const load = () => api.getProjektorDaten(id, 4, token).then(setDaten).catch(() => {});

  useEffect(() => {
    load();
    const interval = setInterval(load, 3000);
    return () => clearInterval(interval);
  }, [id, token]);

  useEffect(() => {
    const uhr = setInterval(() => setJetzt(new Date()), 1000);
    return () => clearInterval(uhr);
  }, []);

  if (!daten) return (
    <div style={{ background: "#0d1b2a", minHeight: "100vh", display: "flex",
                  alignItems: "center", justifyContent: "center", color: "white", fontSize: 24 }}>Lädt…</div>
  );

  const szene = daten.info_szene || "pause";
  const wlanVorhanden = daten.info_wlan_ssid && daten.info_wlan_ssid.trim();

  const bb = <Bauchbinde text={daten.bauchbinde_text} sichtbar={daten.bauchbinde_sichtbar} />;

  const wlanBlock = wlanVorhanden ? (
    <div style={{
      position: "absolute", bottom: 48, left: "50%", transform: "translateX(-50%)",
      background: "rgba(255,255,255,0.08)", borderRadius: 16, padding: "20px 40px",
      display: "flex", gap: 48, alignItems: "center"
    }}>
      <div style={{ fontSize: 36 }}>📶</div>
      <div>
        <div style={{ fontSize: 14, color: "#8aa", textTransform: "uppercase", letterSpacing: 2 }}>WLAN</div>
        <div style={{ fontSize: 26, fontWeight: 700 }}>{daten.info_wlan_ssid}</div>
      </div>
      {daten.info_wlan_passwort && (
        <div>
          <div style={{ fontSize: 14, color: "#8aa", textTransform: "uppercase", letterSpacing: 2 }}>Passwort</div>
          <div style={{ fontSize: 26, fontWeight: 700, fontFamily: "monospace" }}>{daten.info_wlan_passwort}</div>
        </div>
      )}
    </div>
  ) : null;

  const basis = {
    background: "#0d1b2a", minHeight: "100vh", color: "white",
    fontFamily: "Arial, sans-serif", position: "relative",
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
  };

  if (szene === "pause") {
    return (
      <div style={basis}>
        <div style={{ fontSize: 28, color: "#8aa", letterSpacing: 4, textTransform: "uppercase", marginBottom: 20 }}>
          Sitzungspause
        </div>
        <div style={{ fontSize: 140, fontWeight: 800, fontVariantNumeric: "tabular-nums", lineHeight: 1 }}>
          {dayjs(jetzt).format("HH:mm")}
        </div>
        <div style={{ fontSize: 24, color: "#8aa", marginTop: 16 }}>
          {dayjs(jetzt).format("dddd, DD. MMMM YYYY")}
        </div>
        <div style={{ fontSize: 20, color: "#566", marginTop: 40 }}>
          Die Sitzung wird in Kürze fortgesetzt
        </div>
        {wlanBlock}
        {bb}
      </div>
    );
  }

  if (szene === "begruessung") {
    return (
      <div style={basis}>
        <div style={{ fontSize: 80, marginBottom: 24 }}>🚒</div>
        <div style={{ fontSize: 28, color: "#8aa", letterSpacing: 4, textTransform: "uppercase", marginBottom: 16 }}>
          {daten.info_begruessung_text || "Herzlich willkommen"}
        </div>
        <div style={{ fontSize: 56, fontWeight: 800, textAlign: "center", maxWidth: "80%", lineHeight: 1.2 }}>
          {daten.sitzung.titel}
        </div>
        <div style={{ fontSize: 26, color: "#8aa", marginTop: 24 }}>
          {daten.sitzung.gremium} · {dayjs(daten.sitzung.datum).format("DD.MM.YYYY")}
        </div>
        {wlanBlock}
        {bb}
      </div>
    );
  }

  if (szene === "naechster_top") {
    return (
      <div style={basis}>
        <div style={{ fontSize: 28, color: "#8aa", letterSpacing: 4, textTransform: "uppercase", marginBottom: 32 }}>
          Als Nächstes
        </div>
        {daten.naechster_top ? (
          <>
            <div style={{
              fontSize: 48, fontWeight: 800, color: "#cc0000",
              background: "rgba(204,0,0,0.15)", borderRadius: 20,
              width: 120, height: 120, display: "flex", alignItems: "center", justifyContent: "center",
              marginBottom: 32
            }}>
              {daten.naechster_top.nummer}
            </div>
            <div style={{ fontSize: 52, fontWeight: 700, textAlign: "center", maxWidth: "80%", lineHeight: 1.25 }}>
              {daten.naechster_top.titel}
            </div>
          </>
        ) : (
          <div style={{ fontSize: 36, color: "#566" }}>Kein weiterer Tagesordnungspunkt</div>
        )}
        {wlanBlock}
        {bb}
      </div>
    );
  }

  return (
    <div style={basis}>
      <div style={{ fontSize: 36, color: "#566" }}>Info-Screen</div>
      {wlanBlock}
      {bb}
    </div>
  );
}
